import { AIRLINES } from '../constants';
import environments from '../environments';
const ANA2_START_DATE = environments.ANA2_START_DATE;

// ANA2 の場合
export const getIsAna2 = (airline, selectedOutboundDate) => {
  const outbound_date = new Date(selectedOutboundDate);
  const target = new Date(ANA2_START_DATE.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
  const carrierName = airline;
  const isAna2 = (carrierName === AIRLINES['ana']) && (outbound_date >= target);
  return isAna2;
}